import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

// Async function to call the restore endpoint
const restoreFightToEvent = async (
  eventId,
  fightId,
  getAccessTokenSilently
) => {
  const token = await getAccessTokenSilently();
  const apiUrl = process.env.REACT_APP_API_URL;

  await axios.put(
    `${apiUrl}/api/events/restore-fight/${eventId}/${fightId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

// Custom hook
export const useRestoreFightToEvent = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation(
    ({ eventId, fightId }) =>
      restoreFightToEvent(eventId, fightId, getAccessTokenSilently),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("eventDetails");
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message || "Failed to restore fight to event.";
        toast.error(errorMessage);
        console.error("Error restoring fight to event:", error);
      },
    }
  );
};
